export default "__VITE_ASSET__DZuZo0_m__"